import { Box, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { colors, theme } from "../../theme/theme";
import { msgsTabs } from "../../assets/data";
import { CustomInput } from "../Common/CustomInput";
import { SearchOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

const Conversations = ({ selectedChat, setSelectedChat, setOtherUserData }) => {
  const [selectedTab, setSelectedTab] = useState("All");
  const [search, setSearch] = useState("");

  const { conversations } = useSelector((state) => state.chats);
  const { userData } = useSelector((state) => state.user);

  return (
    <Box
      sx={{
        border: theme.lightBorder,
        borderRadius: "18px",
      }}
    >
      <Box sx={{ px: 2, pt: 2 }}>
        <Typography sx={theme.subHeading}>
          Chat ({conversations?.length})
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            mt: 2,
            gap: 1,
          }}
        >
          {msgsTabs.map((tab) => (
            <Box
              key={tab.id}
              sx={{
                width: "100%",
                py: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background:
                  selectedTab === tab.name
                    ? "rgba(247,132,25,0.14)"
                    : "transparent",
                border:
                  selectedTab === tab.name
                    ? `1px solid ${colors.secondary}`
                    : "1px solid rgba(255,255,255,0.2)",
                color: selectedTab === tab.name ? colors.secondary : "#fff",
                fontFamily:
                  selectedTab === tab.name
                    ? "Mulish-SemiBold"
                    : "Mulish-Regular",
                fontSize: "14px",
                borderRadius: "5px",
                cursor: "pointer",
                "&:hover": {
                  background:
                    selectedTab === tab.name
                      ? "rgba(247,132,25,0.5)"
                      : "rgba(255,255,255,0.1)",
                  border:
                    selectedTab === tab.name
                      ? `1px solid ${colors.secondary}`
                      : "1px solid rgba(255,255,255,0.2)",
                  color:
                    selectedTab === tab.name ? colors.secondary : colors.white,
                },
              }}
              onClick={() => setSelectedTab(tab.name)}
            >
              {tab.name}
            </Box>
          ))}
        </Box>

        <CustomInput
          value={search}
          handleChange={(e) => setSearch(e.target.value)}
          rightIcon
          Icon={SearchOutlined}
          borderColor={"rgba(247,132,25,0.5)"}
          placeholder="Search..."
          type="text"
          bR={"9px"}
          mT={2}
          height={"40px"}
          color={"#fff"}
          width={"100%"}
        />
      </Box>

      <Box sx={{ mt: 1 }}>
        {conversations?.map((item, index) => {
          const lastMsg = item?.allMessages?.[item?.allMessages?.length - 1];

          return (
            <Box
              sx={{
                px: 2,
                py: 1.5,
                display: "flex",
                alignItems: "center",
                gap: 2,
                borderBottom: `1px solid rgba(255,255,255,0.2)`,
                borderTop: index === 0 ? `1px solid rgba(255,255,255,0.2)` : "",
                cursor: "pointer",
                borderBottomLeftRadius:
                  index === conversations?.length - 1 ? "18px" : "0px",
                borderBottomRightRadius:
                  index === conversations?.length - 1 ? "18px" : "0px",
                backgroundColor:
                  selectedChat === item?.id ? colors.primary : "transparent",
                "&:hover": {
                  backgroundColor:
                    selectedChat !== item?.id ? "rgba(255,255,255,0.1)" : "",
                  borderBottom:
                    selectedChat !== item?.id
                      ? `1px solid rgba(255,255,255,0.2)`
                      : "",
                },
              }}
              onClick={() => {
                setSelectedChat(item?.id);
                setOtherUserData(item?.user);
              }}
              key={item.id}
            >
              <img
                src={
                  item?.user?.avatar ||
                  require("../../assets/images/default.jpg")
                }
                alt={item?.user?.firstName}
                style={{ width: "50px", height: "50px", borderRadius: "50%" }}
              />
              <Box sx={{ flexGrow: 1 }}>
                <Stack
                  direction={"row"}
                  justifyContent="space-between"
                  alignItems={"center"}
                >
                  <Typography sx={[theme.subHeading, { fontSize: "16px" }]}>
                    {item?.user?.firstName}
                  </Typography>
                  <Typography
                    sx={{
                      color: "rgba(255,255,255,0.5)",
                      fontFamily: "Mulish-Regular",
                      fontSize: "12px",
                    }}
                  >
                    {dayjs(lastMsg?.createdAt).fromNow()}
                  </Typography>
                </Stack>
                <Typography
                  sx={{
                    color: "rgba(255,255,255,0.5)",
                    fontSize: "12px",
                    fontFamily: "Mulish-Light",
                  }}
                >
                  {lastMsg?.sent_by === userData?.id ? "You: " : ""}
                  {lastMsg?.message}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default Conversations;
